
import React from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import AuthService from "services/auth.service";
import MediaQuery from 'react-responsive'

import SelfTicketsTable from  "../components/TicketTables/selfTktsTable"
import SelfTicketsCard from  "../components/TicketTables/selfTktsCard"



import icons from "variables/icons";

class AgentTable extends React.Component {
  render() {


    return (
      <>
        <PanelHeader size="sm" 
        

         />

        <div  className="content">
          <Row>
            <Col md={12}>
              <Card>

                <CardBody className="all-icons">

                <MediaQuery minDeviceWidth={1244}>
                <SelfTicketsTable  tktstates="Active"/> 

                  </MediaQuery>

                  <MediaQuery maxDeviceWidth={1244} >
                <SelfTicketsCard  tktstates="Active"/> 

                  </MediaQuery>


                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default AgentTable;
